import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';
import {type SwiperOptions} from "swiper/types";

export default class EtSwiper {
    static observer: IntersectionObserver;

    constructor() {
        this.initObserver();
    }

    private initObserver() {
        if (!EtSwiper.observer) {
            EtSwiper.observer = new IntersectionObserver(
                this.handleSwiperIntersection,
                {
                    root: null, // Das Viewport ist das Root-Element
                    rootMargin: '0px', // Kein Margin
                    threshold: 0.1 // 10% des Elements im Viewport
                }
            );
        }
    }

    handleSwiperIntersection(entries: IntersectionObserverEntry[], observer: IntersectionObserver) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                // Observer beenden
                observer.unobserve(entry.target);
                if (entry.target instanceof HTMLElement) {
                    entry.target.dataset.observation = 'terminated';
                    this.initSwiper(entry.target);
                }
            }
        });
    }

    observeEtSwipers() {
        document.querySelectorAll('.swiper').forEach((element) => {
            if (element instanceof HTMLElement
                && !element.classList.contains('swiper-initialized')
                && !element.dataset.observation
            ) {
                element.dataset.observation = 'running';
                EtSwiper.observer.observe(element);
            }
        });
    }

    async initSwiper(swiperElement: HTMLElement, swiperOptions: SwiperOptions | null = null): Promise<Swiper | null> {
        if (!(swiperElement instanceof HTMLElement)
            || !swiperElement.classList.contains('swiper')
            || swiperElement.classList.contains('swiper-initialized')
        ) {
            return new Promise<null>((resolve) => {
                resolve(null);
            });
        }

        if (!swiperOptions) {
            swiperOptions = this.getSwiperConfig(swiperElement);
        }

        //console.log('initSwiper', {swiperElement, swiperOptions});

        // Swiper initialisieren
        return new Swiper(swiperElement, swiperOptions);
    }

    getSwiperConfig(swiperElement: HTMLElement): SwiperOptions {
        let cssGridGutterHorizontal = 10;
        let cssGridGutterLargeHorizontal = 25;

        let options: SwiperOptions = {
            modules: [Navigation, Pagination],
            loop: false,
            slidesPerView: 1,
            spaceBetween: cssGridGutterHorizontal,
        };

        let breakpointDesktop = 1024;
        let configBreakpoints: any = {};
        configBreakpoints[breakpointDesktop] = {
            spaceBetween: cssGridGutterLargeHorizontal,
        }

        let paginationElement = swiperElement.querySelector('.swiper-pagination');
        if (paginationElement instanceof HTMLElement) {
            options.pagination = {
                el: paginationElement,
                clickable: true
            }
        }

        let navigationButton1 = swiperElement.querySelector('.swiper-button-prev');
        let navigationButton2 = swiperElement.querySelector('.swiper-button-next');
        if (navigationButton1 || navigationButton2) {
            options.navigation = {};
            if (navigationButton1 instanceof HTMLElement) {
                options.navigation.prevEl = navigationButton1;
            }
            if (navigationButton2 instanceof HTMLElement) {
                options.navigation.nextEl = navigationButton2;
            }
        }

        const dataSliderPreset = swiperElement.dataset.sliderPreset || '';
        switch (dataSliderPreset) {
            case 'slideshow':
                options.loop = true;
                break;

            case 'teaser_artdirection':
                options.autoplay = {
                    delay: 4000
                };
                break;

            case 'gallery':
                options.slidesPerView = 'auto';
                options.loop = true;
                options.grabCursor = true;
                options.spaceBetween = 15
                break;

            case 'product_slider':
            case 'productslider':
                options.slidesPerView = 'auto';
                options.loop = true;
                options.grabCursor = true;
                options.spaceBetween = 0;
                break;

            case 'klevu_slider':
                options.slidesPerView = 1;
                options.loop = true;
                options.grabCursor = true;
                options.spaceBetween = 15;
                configBreakpoints[400] = { slidesPerView: 2 };
                configBreakpoints[768] = { slidesPerView: 3 };
                configBreakpoints[breakpointDesktop] = { slidesPerView: 4 };
                break;

            default:
                /*switch (dataSliderPreset) {
                    case 'productslider':
                        // @ts-ignore
                        options.spaceBetween = 2;
                        options.slidesPerView = 'auto';
                        break;
                }

                let firstSlide = swiperElement.querySelector('.swiper-slide');
                if (firstSlide) {
                    firstSlide.classList.forEach((className) => {
                        let matches;
                        if (typeof className === 'string'
                            && className.length > 8
                            && (matches = className.match(/uk-width(-small|-medium|-large|-xlarge)?-([0-9])-([0-9])$/))
                        ) {
                            let bp = matches[1] ? matches[1].substr(1) : null;
                            let zaehler = parseInt(matches[2]);
                            let nenner = parseInt(matches[3]);

                            if (zaehler === 1) { // 1 of n
                                if (bp === null) {
                                    options.slidesPerView = nenner;
                                } else {
                                    let w = et.app.getBreakpointMin(bp);
                                    if (w) {
                                        if (configBreakpoints.hasOwnProperty(w)) {
                                            configBreakpoints[w].slidesPerView = nenner;
                                        } else {
                                            configBreakpoints[w] = {slidesPerView: nenner};
                                        }
                                    }
                                }
                            }
                        }
                    });
                }*/
                break;
        }

        /**
         * TODO: config object deep merge ... jQuery.extend(true, )
         * Der Plan ist:
         * data-slider-preset gibt eine Basiskonfigurationen vor.
         * data-slider-config|data-swiper-config mach einzelne Definitionen und Überschreibungen möglich
         */

        /*let sliderConfig = et.js.uikitStr2json(swiperElement.dataset.sliderConfig || swiperElement.dataset.swiperConfig);
        if (sliderConfig) {
            for (const sliderConfigKey in sliderConfig) {
                let cKey: string = sliderConfigKey;
                let cVal: any = sliderConfig[sliderConfigKey];

                if (cVal === 'true') {
                    cVal = true;
                } else if (cVal === 'false') {
                    cVal = false;
                }

                // map uikit stuff to swiper
                switch (sliderConfigKey) {
                    case 'infinite':
                        cKey = 'loop';
                        break;
                    case 'gap':
                        if (cVal === true) {
                            // @ts-ignore
                            options.spaceBetween = cssGridGutterHorizontal;
                            // if (configBreakpoints.hasOwnProperty(breakpointDesktop)) {
                            //     configBreakpoints[breakpointDesktop].spaceBetween = cssGridGutterLargeHorizontal;
                            // } else {
                            //     configBreakpoints[breakpointDesktop] = {
                            //         spaceBetween: cssGridGutterLargeHorizontal
                            //     }
                            // }
                        }
                        break;
                }

                // @ts-ignore
                config[cKey] = cVal;
            }
        }*/

        if (Object.keys(configBreakpoints).length > 0) {
            options.breakpoints = configBreakpoints;
        }

        return options;
    }
}
